import React, { useState } from 'react';
import { toast } from 'react-toastify';
import { forgotPassword } from '../../services/authService';

function ForgotPassword() {
    const [email, setEmail] = useState('');
    const [loading, setLoading] = useState(false);

    const handleSubmit = async (e) => {
        e.preventDefault();

        if (!email) {
            toast.error('Please enter your email address');
            return;
        }

        const emailRegex = /^[^\s@]+@[^\s@]+\.[^\s@]+$/;
        if (!emailRegex.test(email)) {
            toast.error('Please enter a valid email address');
            return;
        }

        setLoading(true);

        try {
            const response = await forgotPassword({ email });
            toast.success(response.message || 'Password reset link has been sent to your email');
            setEmail('');
        } catch (err) {
            toast.error(err.response?.data?.message || 'Failed to send reset link. Please try again.');
        } finally {
            setLoading(false);
        }
    };

    return (
        <>
            <main className="login forgot">
                <div
                    className="login-left right"
                    style={{
                        backgroundImage: `url(${window.getPublicUrl('admin/images/login-right-img.png')})`,
                        backgroundSize: "cover",
                    }}
                ></div>
                <div className="login-left">
                    <div className="login-left-inner">
                        <div className="logi-logo">
                            <img src={window.getPublicUrl('admin/images/logo.svg')} alt="logo" />
                        </div>
                        <div className="login-mid">
                            <h3>Forgot Password?</h3>
                            <p>Enter your registered email address to reset your password.</p>

                            <form onSubmit={handleSubmit}>
                                <div className="form-group">
                                    <label htmlFor="exampleInputEmail1">Email</label>
                                    <input
                                        type="email"
                                        className="form-control"
                                        id="exampleInputEmail1"
                                        aria-describedby="emailHelp"
                                        value={email}
                                        onChange={(e) => setEmail(e.target.value)}
                                        disabled={loading}
                                    />
                                </div>

                                <button
                                    type="submit"
                                    className="btn"
                                    disabled={loading}
                                >
                                    {loading ? 'Sending...' : 'Send Reset Link'}
                                </button>
                            </form>
                        </div>

                        <h4>
                            <a href="/admin/login">Back to Login</a>
                        </h4>
                    </div>
                </div>
            </main>
        </>
    );
}

export default ForgotPassword;
